import { CAR_PURCHASE_STATUS } from 'src/constants/constants';
import type { CarBadgesTypes } from 'src/pdp/components/Car360V1/CarBadges.types';

export interface ProductDetailsPayload {
  id: string;
  sku: string;
  published: boolean;
  vin: string;
  state: CAR_PURCHASE_STATUS;
  // FIXME proper type for this field is string
  price: number;
  dutyPrice: string;
  totalPrice: string;
  transferFee: string;
  make: string;
  model: string;
  variant: string;
  driveType: string;
  // FIXME proper type for this field is number
  numberOfKeys: string;
  breadcrumbs: ProductDetailBreadcrumb[];
  buildYear: number;
  badge: string;
  body: string;
  engineSize: string;
  enginePower: string;
  cylinders: string;
  transmission: string;
  seats: number;
  kilometres: string;
  colour: string;
  complianceYear: number;
  fuelType: string;
  fuelCapacity: string;
  fuelConsumption: string;
  batteryCapacity: string;
  electricRange: string;
  energyConsumption: string;
  gears: string;
  doors: number;
  length: string;
  weight: string;
  emissions: string;
  description: string;
  standardFeatures: string[];
  optionalFeatures: string[];
  aftermarketFeatures: string[];
  highlightedFeatures: { key: string; label: string }[];
  detailedHighlightedFeatures: string[];
  serviceHistory: ServiceHistory[];
  lastService: string;
  images: ProductDetailsPayloadImages;
  ancapRating: string;
  defaultRate: number;
  weeklyRepayment: number;
  towCapBraked: string;
  watchers?: number;

  search_keywords: string[];
  [ProductDetailsPayloadFields.warrantyExpiryDate]: string | null;
  [ProductDetailsPayloadFields.warrantyExpiryKms]: string;
  [ProductDetailsPayloadFields.remainingWarrantyMonths]: number;
  [ProductDetailsPayloadFields.remainingWarrantyKilometres]: number;
  [ProductDetailsPayloadFields.unlimitedKilometresFlag]: boolean;
  badges: ProductDetailBadge[];
  hotspots?: HotspotData;
}

export enum ProductDetailsPayloadFields {
  warrantyExpiryDate = 'warranty_expiry_date',
  warrantyExpiryKms = 'warranty_expiry_kms',
  remainingWarrantyMonths = 'remaining_warranty_months',
  remainingWarrantyKilometres = 'remaining_warranty_kilometres',
  unlimitedKilometresFlag = 'unlimited_kilometres_flag',
}

interface ProductDetailBreadcrumb {
  link: string;
  text: string;
}

export interface ProductDetailsPayloadImages {
  '360doorsclosed': Card[];
  '360doorsopen': Card[];
  card: Card;
  damage: Damage[];
  gallery: ProductDetailGalleryImage[];
  interior: Card[];
}

interface Card {
  name: string;
  url: string;
  thumbnailUrl?: string;
}

export interface Damage {
  additionalInfo: AdditionalInfo;
  name: string;
  url: string;
}

interface AdditionalInfo {
  X: string;

  X_percent: string;
  Y: string;

  Y_percent: string;
  actual: string;
  part: string;

  reference_url: string;
  tag: string;
}

export interface ProductDetailGalleryImage {
  name: string;
  url: string;
  background?: boolean;
}

interface ServiceHistory {
  serviceDate: string;
  kilometres: number;
  recordFormat?: string;
  provider: string;
}

export interface ProductDetailBadge {
  name: CarBadgesTypes;
  reference: number | null;
}

export interface HotspotsExterior {
  name: string;
  image?: string;
  description?: string;
  points: {
    frame: number;
    x: number;
    y: number;
  }[];
}

export interface HotspotsInterior {
  name: string;
  image?: string;
  description?: string;
  point: {
    yaw: number;
    pitch: number;
  };
}

export interface HotspotData {
  interior: HotspotsInterior[];
  exterior: HotspotsExterior[];
}
